import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio01.jpg'
import IMG2 from '../../assets/portfolio02.jpg'
import IMG3 from '../../assets/portfolio03.jpg'
import IMG4 from '../../assets/portfolio04.jpg'
import IMG5 from '../../assets/portfolio05.jpg'
import IMG6 from '../../assets/portfolio06.jpg'

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
      <article className='portfolio__item'>
      <div className="portfolio__item-image">
        <img src={IMG1} alt="" />
      </div>
      <h3>Side Project Sandbox</h3>
      <div className="portfolio__item-cta">
      <a href="https://app.notion.com/templates/side-project-sandbox" className='btn btn-primary' target='_blank'>View live template</a>
      </div>
      </article>
      <article className='portfolio__item'>
      <div className="portfolio__item-image">
        <img src={IMG2} alt="" />
      </div>
      <h3>Content Sprint Planner</h3>
      <div className="portfolio__item-cta">
      <a href="https://app.notion.com/templates/content-sprint-planner" className='btn btn-primary' target='_blank'>View live template</a>
      </div>
      </article>
      <article className='portfolio__item'>
      <div className="portfolio__item-image">
        <img src={IMG3} alt="" />
      </div>
      <h3>Thesis & Academic Research Navigator</h3>
      <div className="portfolio__item-cta">
      <a href="https://app.notion.com/templates/thesis-academic-research-navigator" className='btn btn-primary' target='_blank'>View live template</a>
      </div>
      </article>
      <article className='portfolio__item'>
      <div className="portfolio__item-image">
        <img src={IMG4} alt="" />
      </div>
      <h3>Focus Lab: The Neurodivergent OS</h3>
      <div className="portfolio__item-cta">
      <a href="https://app.notion.com/templates/focus-lab-the-neurodivergent-os" className='btn btn-primary' target='_blank'>View live template</a>
      </div>
      </article>
      <article className='portfolio__item'>
      <div className="portfolio__item-image">
        <img src={IMG5} alt="" />
      </div>
      <h3>The Chronic Illness Symptom & Smart Medication Log</h3>
      <div className="portfolio__item-cta">
      <a href="https://app.notion.com/templates/the-chronic-illness-symptom-smart-medication-log" className='btn btn-primary' target='_blank'>View live template</a>
      </div>
      </article>
      <article className='portfolio__item'>
      <div className="portfolio__item-image">
        <img src={IMG6} alt="" />
      </div>
      <h3>The Private Tutor’s Lesson Ledger</h3>
      <div className="portfolio__item-cta">
      <a href="https://app.notion.com/templates/the-private-tutor-s-lesson-ledger" className='btn btn-primary' target='_blank'>View live template</a>
      </div>
      </article>
      </div>
    </section>
  )
}

export default Portfolio